module.exports = __webpack_public_path__ + "static/media/icono_actuacion.fbdc1636.svg";